import { ReportHandler } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;

// New function to send web vitals to Google Analytics
export const sendToGoogleAnalytics = ({ name, delta, value, id }: { name: string; delta: number; value: number; id: string }) => {
  // Assumes the global `gtag()` function exists, thanks to the snippet added to index.html
  const gtag = (window as any).gtag;
  
  if (gtag) {
    // GA4 automatically captures some web vitals, but we can send additional data for more detail
    gtag('event', name, {
      // Event parameters
      value: Math.round(name === 'CLS' ? delta * 1000 : delta), // CLS needs special handling
      metric_id: id,
      metric_value: value,
      metric_delta: delta,
      // Standard parameters
      event_category: 'Web Vitals',
      event_label: id,
      non_interaction: true, // Avoid impacting bounce rate
    });
  }
};
